module.exports = __webpack_public_path__ + "static/media/B_E01.1bda31d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_E01.png
// module id = 86
// module chunks = 0